import { Component, OnInit } from '@angular/core';
import { AuthService } from '@common/services/AuthService/AuthService';
import { EmployeeService } from '@common/services/EmployeeService/EmployeeService';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalService } from '@common/services/ModalService/ModalService';
import { EmployeeDetails } from '@common/models/employeeDetails.model';

@Component({
  templateUrl: './employeeDetailsView.component.html',
  styleUrls: ['./employeeDetailsView.component.scss'],
})
export class EmployeeDetailsViewComponent implements OnInit {
  public employeeDetails: EmployeeDetails = {
    employeeKey: null,
    employeeFirstName: null,
    employeeLastName: null,
    employeeEmail: null,
    employeePhone: null,
    clientAssigned: [],
  };
  public bottomLevelName: string;
  public employeeKey: string;
  notFound = false;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public authService: AuthService,
    public employeeService: EmployeeService,
    public modalService: ModalService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.employeeKey = params['employeeKey'];
      this.getInitialData();
    });
  }

  handleNotFound(): void {
    this.bottomLevelName = '404';
    this.notFound = true;
  }

  getInitialData(): void {
    this.employeeService.getEmployeeDetails(this.employeeKey)
      .subscribe(
        (data: EmployeeDetails): void => {
          this.employeeDetails = data;
          this.bottomLevelName = `${this.employeeDetails.employeeFirstName} ${this.employeeDetails.employeeLastName}`;
        },
        (error) => {
          if (error.status === 404) {
            this.handleNotFound();
          } else {
            this.authService.handleRequestError(error, this.getInitialData.bind(this));
          }
        },
      );
  }

  deleteEmployee(): void {
    const proceedEmployeeDeletion = (): void => {
      this.modalService.closeModal();
      this.employeeService.deleteEmployee(this.employeeKey)
        .subscribe(
          (res: null) => {
            this.modalService.openModal({ type: 'employeeDeleted' });
            this.router.navigateByUrl(`/employees`);
          },
          (err) => {
            this.modalService.openModal({ type: 'errorOccurred' });
          },
        );
    };

    this.modalService.openModal({
      type: 'deleteEmployee',
      data: {
        employeeName: `${this.employeeDetails.employeeFirstName} ${this.employeeDetails.employeeLastName}`,
      },
      callback: proceedEmployeeDeletion,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/employees/views/employeeDetailsView/employeeDetailsView.ts